import { useNavigate } from 'react-router-dom';

import useTranslations from '@/i18n/useTranslations';
import { createCommunityArtworkNavigationState } from '@/shared/lib/communityArtworkNavigation';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import CardHeader from '@/shared-components/cards/components/CardHeader';
import ArtworkRatingDisplayer from '@/shared-components/inputs/components/ArtworkRatingDisplayer';
import Utils from '@/utils';
import { hasRenderableRating } from '@/utils/activityContent';

import './styles/ArtworkInlineTitle.css';
import './styles/CommunityRatingCard.css';

export default function CommunityRatingCard({ data, actor }) {
  const navigate = useNavigate();
  const t = useTranslations('common.shared.community_feed');
  const tRatingForm = useTranslations('common.shared.artwork_view.socials.ratings.form');
  if (!hasRenderableRating(data)) {
    return null;
  }

  return (
    <>
      <div
        className="community-rating-card__container"
        onClick={() => navigate(`/artwork/${data.rating_artwork.slug}`, {
          state: createCommunityArtworkNavigationState(),
        })}
      >
        <CardHeader
          image={actor?.image}
          profileType={actor?.profileType}
          username={actor?.username}
          onUserClick={() => navigate(`/user/${actor?.username}`)}
          timeAgo={Utils.elapsedTime(new Date(data.createdAt).getTime())}
          subtitle={
            <>
              {t('activity.rated')} <span className="artwork-inline-title">{data.rating_artwork.artwork_about.artwork_title}</span>
            </>
          }
        />

        <ArtworkImage
          image={data.rating_artwork.artwork_media.artwork_main_picture.image_id}
          imageClassName="community-rating-card__artwork-image"
          imageTemplateClassName="community-rating-card__artwork-image"
          // forceSmaller={300}
        />

        <div className="community-rating-card__ratings">
          <ArtworkRatingDisplayer
            className="community-rating-card__rating"
            category={tRatingForm('categories.emotions.title')}
            username={actor?.username}
            userRating={data.rating_values.emotions}
            myRating={data.my_rating.rating_values.emotions}
          />

          <ArtworkRatingDisplayer
            className="community-rating-card__rating"
            category={tRatingForm('categories.style.title')}
            username={actor?.username}
            userRating={data.rating_values.style}
            myRating={data.my_rating.rating_values.style}
          />

          <ArtworkRatingDisplayer
            className="community-rating-card__rating"
            category={tRatingForm('categories.time_travel.title')}
            username={actor?.username}
            userRating={data.rating_values.time_travel}
            myRating={data.my_rating.rating_values.time_travel}
          />
        </div>
      </div>
    </>
  );
}
